<!-- Backwards-compatibility wrapper. New code should import DateRangeSelector directly. -->
<script setup lang="ts">
import DateRangeSelector from '@/components/v2/DateRangeSelector.vue';
import type { DateChangePayload } from '@/types/components/DateChangePayload';

defineProps<{
  initialStartDate: Date;
  initialEndDate: Date;
  onApply: (payload: DateChangePayload) => void;
}>();
</script>

<template>
  <DateRangeSelector
    :initial-start-date="initialStartDate"
    :initial-end-date="initialEndDate"
    :on-apply="onApply" />
</template>
